import { render, staticRenderFns } from "./anchors.vue?vue&type=template&id=b8e8f2a8"
import script from "./anchors.vue?vue&type=script&lang=js"
export * from "./anchors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports